module.exports = __webpack_public_path__ + "static/img/product1.699800e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product1.png
// module id = 3jkA
// module chunks = 1